import React from "react";
import { Form, Button, Row, Col, Input, DatePicker } from "antd";
import MultipleDatePicker from "./components/MultiDatePicker";
import { createWorkFromHomeExcel } from "./utils/excelUtils";

const WorkFromHomeForm = () => {
    const [selectedMonth, setSelectedMonth] = React.useState(null);

    const handleSubmit = async values => {
        try {
            await createWorkFromHomeExcel(values);
        } catch (error) {
            console.error("Error creating Excel file:", error);
        }
    };

    return (
        <Form onFinish={handleSubmit}>
            <Row>
                <Col span={24}>
                    <Form.Item
                        name="month"
                        label="Declaratie maand"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            { required: true, message: "Selecteer een maand" },
                        ]}
                    >
                        <DatePicker
                            picker="month"
                            onChange={setSelectedMonth}
                        />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="Naam"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: true, message: "Vul je naam in" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="city"
                        label="Woonplaats"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            { required: true, message: "Vul je woonplaats in" },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item
                        name="dates"
                        label="Welke dagen werkte je thuis?"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            {
                                required: true,
                                message: "Selecteer ten minste één dag",
                            },
                        ]}
                    >
                        <MultipleDatePicker
                            selectedMonth={selectedMonth}
                            format="DD-MM-YYYY"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row justify="end">
                <Col>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Excel downloaden
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default WorkFromHomeForm;
